import Cookies from "js-cookie";
import Vue from "vue";
import {
  AddNotificationCountToIndexedDB,
  AddReadNotificationToIndexedDB,
  AddUnreadNotificationToIndexedDB,
  ClearNotificationIndexedDB,
  GetNotificationCountFromIndexedDB,
  GetReadNotificationFromIndexedDB,
  GetUnreadNotificationFromIndexedDB,
  UpdateNotificationCountToIndexedDB,
  UpdateReadNotificationToIndexedDB,
  UpdateUnreadNotificationToIndexedDB,
} from "../IndexedDB/notificationIndexedDB";
import { ClearTabFromIndexedDB } from "../IndexedDB/tabIndexedDB";
import {
  BroadcastDisconnectNotificationAllTab,
  BroadcastIsUpdateIsSeenNotificationList,
  BroadcastIsUpdateNotificationCount,
  BroadcastIsUpdateUnSeenNotificationList,
  BroadcastMasterDeleteNotificationById,
  BroadcastMasterSetNotificationIsSeenAll,
  BroadcastMasterSetNotificationIsSeenById,
  BroadcastReCreateTab,
} from "../broadcastChannel/userChannel";
import store from "../controller/baseController";
import enums from "../enums/enums";
import userInfo from "../function/userInfo";
import i18n from "../locales/i18n";
import shareHelper from "./shareHelper";
import {
  ClearMasterTabFromCookies,
  ClearTabFromSessionStorage,
  GetAllTabs,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  IsMasterTabAvailable,
  SetMasterTab,
  UpdateTabMerchantId,
} from "./tabHelper";
const appVue = new Vue();
const socketSessionIdKey = "socketSessionId";

export const GetSocketSessionIdFromCookies = () => {
  let socketSessionId = Cookies.get(socketSessionIdKey);
  return socketSessionId ? socketSessionId : null;
};

export const SetSocketSessionIdFromCookies = () => {
  if (appVue.$socket && appVue.$socket.connected) {
    const socketSessionId = appVue.$socket.id;
    Cookies.set(socketSessionIdKey, socketSessionId);
  }
};

export const RemoveSocketSessionIdFromCookies = () => {
  Cookies.remove(socketSessionIdKey);
};

export const CheckStatusSocket = () => {
  if (IsMasterTab()) {
    if (!appVue.$socket || appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const SocketConnect = () => {
  if (IsMasterTab()) {
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (!IsMasterTabAvailable()) {
    SetMasterTab();
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else {
    store.commit("MutationSetNotificationReadyToUse", true);
  }
};

export const SocketAuthentication = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    let eui = btoa(userInfo.UserId());
    let accessToken = userInfo.GetAccessToken();
    appVue.$socket.emit("authentication", {
      eui: eui,
      accessToken: accessToken,
    });
  }
};

export const SocketDisconnect = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const DoGetAllNotificationList = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoGetAllNotificationList", merchantId);
  }
};

export const DoGetUnSeenNotificationList = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoGetUnSeenNotificationList", merchantId);
  }
};

export const DoGetIsSeenNotificationList = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoGetIsSeenNotificationList", merchantId);
  }
};

export const DoGetUnseenNotificationCount = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoGetUnseenNotificationCount", merchantId);
  }
};

export const DoDeleteSeenNotification = (merchantId, notificationId, isSeen) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoDeleteSeenNotification", { merchantId: merchantId, notificationId: notificationId });
  }
};

export const DoDeleteUnseenNotification = (merchantId, notificationId, isSeen) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoDeleteUnseenNotification", { merchantId: merchantId, notificationId: notificationId });
  }
};

export const DoSetAllNotificationIsSeen = async (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    await store.dispatch("DoSetAllNotificationIsSeen", merchantId);
  }
};

export const DoSetNotificationIsSeen = async (merchantId, notificationId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    await store.dispatch("DoSetNotificationIsSeen", { merchantId: merchantId, notificationId: notificationId });
  }
};

export const DoAddNotificationCount = async (merchantId, notificationCount) => {
  let notificationCountModelForInsert = {
    merchantId: merchantId,
    notificationCount: notificationCount,
  };
  let notificationCountModel = await GetNotificationCountFromIndexedDB(merchantId);
  if (notificationCountModel) {
    await UpdateNotificationCountToIndexedDB(notificationCountModelForInsert);
  } else {
    await AddNotificationCountToIndexedDB(notificationCountModelForInsert);
  }
};

export const DoGetNotificationCount = async (merchantId) => {
  let notificationCountModel = await GetNotificationCountFromIndexedDB(merchantId);
  return notificationCountModel ? notificationCountModel.notificationCount : 0;
};

export const DoAddUnreadNotificationList = async (merchantId, notificationList) => {
  let notificationModelForInsert = {
    merchantId: merchantId,
    notificationList: notificationList,
  };

  let notificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);

  if (notificationModel) {
    await UpdateUnreadNotificationToIndexedDB(notificationModelForInsert);
  } else {
    await AddUnreadNotificationToIndexedDB(notificationModelForInsert);
  }
};

export const DoGetReadAllNotificationList = async (merchantId) => {
  let notificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  return notificationModel ? notificationModel.notificationList : [];
};

export const DoAddReadNotificationList = async (merchantId, notificationList) => {
  let notificationModelForInsert = {
    merchantId: merchantId,
    notificationList: notificationList,
  };
  let notificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  if (notificationModel) {
    await UpdateReadNotificationToIndexedDB(notificationModelForInsert);
  } else {
    await AddReadNotificationToIndexedDB(notificationModelForInsert);
  }
};

export const DoGetUnreadAllNotificationList = async (merchantId) => {
  let notificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);
  return notificationModel ? notificationModel.notificationList : [];
};

export const DoDeleteNotificationById = async (merchantId, notificationId, isSeen) => {
  if (IsMasterTab()) {
    if (isSeen) {
      DoDeleteSeenNotification(merchantId, notificationId);
    } else {
      DoDeleteUnseenNotification(merchantId, notificationId);
    }
    await DoDeleteNotificationByIdFromSOCKET(merchantId, notificationId);
  } else {
    BroadcastMasterDeleteNotificationById(merchantId, notificationId, isSeen);
  }
};

export const DoDeleteNotificationByIdFromSOCKET = async (merchantId, notificationId) => {
  if (IsMasterTab()) {
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = RemoveNotificationFromNotificationList(readNotificationList, notificationId);
    await UpdateReadNotificationToIndexedDB({ merchantId: merchantId, notificationList: readNotificationList });

    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = RemoveNotificationFromNotificationList(unreadNotificationList, notificationId);
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: unreadNotificationList });
    let notificationCount = await DoGetNotificationCount(merchantId);
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: notificationCount - 1 });

    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.commit("MutationSetUnSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.commit("MutationSetIsSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  }
};

export const DoSetNotificationIsSeenAll = async (merchantId) => {
  if (IsMasterTab()) {
    await DoSetAllNotificationIsSeen(merchantId);
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: [] });
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: 0 });

    await DoAddReadNotificationList(merchantId, [...unreadNotificationList, ...readNotificationList]);

    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.commit("MutationSetUnSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.commit("MutationSetIsSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  } else {
    BroadcastMasterSetNotificationIsSeenAll(merchantId);
  }
};

export const DoSetNotificationIsSeenAllFromSOCKET = async (merchantId) => {
  if (IsMasterTab()) {
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: [] });
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: 0 });

    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    if (unreadNotificationList && unreadNotificationList.length > 0) {
      await DoAddReadNotificationList(merchantId, [...unreadNotificationList, ...readNotificationList]);
    } else if (readNotificationList && readNotificationList.length > 0) {
      DoGetIsSeenNotificationList(merchantId);
    }

    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.commit("MutationSetUnSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.commit("MutationSetIsSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  }
};

export const DoSetNotificationIsSeenById = async (merchantId, notificationId) => {
  if (IsMasterTab()) {
    await DoSetNotificationIsSeen(merchantId, notificationId);
    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);
    const unreadNotificationCount = await DoGetNotificationCount(merchantId);
    const unreadNotification = unreadNotificationList.find((x) => x.id == notificationId);
    if (unreadNotification) {
      await UpdateNotificationCountToIndexedDB({
        merchantId: merchantId,
        notificationCount: unreadNotificationCount - 1,
      });

      unreadNotification.isSeen = true;
      await DoAddReadNotificationList(merchantId, [...readNotificationList, unreadNotification]);
    }

    await UpdateUnreadNotificationToIndexedDB({
      merchantId: merchantId,
      notificationList: unreadNotificationList.filter((x) => x.id !== notificationId),
    });

    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.commit("MutationSetUnSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.commit("MutationSetIsSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  } else {
    BroadcastMasterSetNotificationIsSeenById(merchantId, notificationId);
  }
};

export const DoSetNotificationIsSeenByIdFromSOCKET = async (merchantId, notificationId) => {
  if (IsMasterTab()) {
    const unreadNotificationCount = await DoGetNotificationCount(merchantId);
    await UpdateNotificationCountToIndexedDB({
      merchantId: merchantId,
      notificationCount: unreadNotificationCount - 1,
    });

    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);

    if (unreadNotificationList && unreadNotificationList.length > 0) {
      const unreadNotification = unreadNotificationList.find((x) => x.id == notificationId);

      if (unreadNotification) {
        unreadNotification.isSeen = true;
        await DoAddReadNotificationList(merchantId, [...readNotificationList, unreadNotification]);
      }

      await UpdateUnreadNotificationToIndexedDB({
        merchantId: merchantId,
        notificationList: unreadNotificationList.filter((x) => x.id !== notificationId),
      });
    } else if (readNotificationList && readNotificationList.length > 0) {
      DoGetIsSeenNotificationList(merchantId);
    }

    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.commit("MutationSetUnSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.commit("MutationSetIsSeenNotificationListFromIndexedDB");
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  }
};

export const RemoveNotificationFromNotificationList = (notificationList, notificationId) => {
  if (notificationList && notificationList.length > 0) {
    let findIndex = notificationList.findIndex((x) => x.id === notificationId);
    if (findIndex > -1) {
      notificationList.splice(findIndex, 1);
      return notificationList;
    }
    return notificationList;
  }
  return [];
};

export const SetIsSeenForNotification = (notificationList, isSeen) => {
  if (notificationList && notificationList.length > 0) {
    notificationList.forEach((notificationItem) => {
      notificationItem.isSeen = isSeen;
    });
    return notificationList;
  }
  return [];
};

export const SortDataNotification = (notificationList) => {
  if (notificationList && notificationList.length > 0) {
    return notificationList.sort((a, b) => {
      const notificationDateTimeA = new Date(a.notificationDateTime);
      const notificationDateTimeB = new Date(b.notificationDateTime);
      return notificationDateTimeB - notificationDateTimeA;
    });
  }
  return [];
};

export const GetObjectIdListNotification = (notificationList) => {
  const userIdList = [];
  const purchaseRequisitionIdList = [];
  const quotationIdList = [];
  const depositIdList = [];
  const goodsReceiptIdList = [];
  const invoiceReceiptIdList = [];
  const invoiceIdList = [];
  const receiptIdList = [];
  const taxInvoiceIdList = [];
  const creditNoteIdList = [];
  const debitNoteIdList = [];
  const billingNoteIdList = [];
  const journalIdList = [];
  const pnd2IdList = [];
  const pnd3IdList = [];
  const pnd53IdList = [];
  const pp30IdList = [];
  const productIdList = [];
  const assetTemplateIdList = [];
  const bankAccountIdList = [];

  if (notificationList && notificationList.length > 0) {
    for (const notification of notificationList) {
      if (notification.userId > 0) {
        userIdList.push(notification.userId);
      }
      if (notification.option && notification.option.referenceUserId > 0) {
        userIdList.push(notification.option.referenceUserId);
      }
      if (notification.messageTypeId == enums.NotificationMessageType.MentionTransaction) {
        const userIds = shareHelper.GetUserIdFromCommentText(notification.option.messageDescription);
        userIdList.push(...userIds);
      }

      if (notification.option.productId > 0) {
        productIdList.push(notification.option.productId);
      }

      if (notification.option.assetTemplateId > 0) {
        assetTemplateIdList.push(notification.option.assetTemplateId);
      }

      if (notification.option.transactionType == enums.TransactionType.TaxPND2) {
        pnd2IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.TaxPND3) {
        pnd3IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.TaxPND53) {
        pnd53IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.TaxPP30) {
        pp30IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.PurchaseRequisition) {
        purchaseRequisitionIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.Quotation) {
        quotationIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.Deposit) {
        depositIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.GoodsReceipt) {
        goodsReceiptIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.InvoiceReceipt) {
        invoiceReceiptIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.Invoice) {
        invoiceIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.Receipt) {
        receiptIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.TaxInvoice) {
        taxInvoiceIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.CreditNote) {
        creditNoteIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.DebitNote) {
        debitNoteIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.BillingNote) {
        billingNoteIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == enums.TransactionType.Dailyjournal) {
        journalIdList.push(notification.option.transactionId);
      }
      if (notification.option.bankAccountId > 0) {
        bankAccountIdList.push(notification.option.bankAccountId);
      }
    }
  }
  return {
    userIdList,
    purchaseRequisitionIdList,
    quotationIdList,
    depositIdList,
    goodsReceiptIdList,
    invoiceReceiptIdList,
    invoiceIdList,
    receiptIdList,
    taxInvoiceIdList,
    creditNoteIdList,
    debitNoteIdList,
    billingNoteIdList,
    journalIdList,
    pnd2IdList,
    pnd3IdList,
    pnd53IdList,
    pp30IdList,
    productIdList,
    assetTemplateIdList,
    bankAccountIdList,
  };
};

export const GetAllDataForDisplayNotification = async (objectId, notificationList, merchant) => {
  //#region Get User Detail
  await store.dispatch("DoGetUserDetailForDisplay", objectId.userIdList);
  //#endregion

  //#region Get Transaction Code
  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.purchaseRequisitionIdList,
    transactionType: enums.TransactionType.PurchaseRequisition,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.quotationIdList,
    transactionType: enums.TransactionType.Quotation,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.depositIdList,
    transactionType: enums.TransactionType.Deposit,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.goodsReceiptIdList,
    transactionType: enums.TransactionType.GoodsReceipt,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.invoiceReceiptIdList,
    transactionType: enums.TransactionType.InvoiceReceipt,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.invoiceIdList,
    transactionType: enums.TransactionType.Invoice,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.receiptIdList,
    transactionType: enums.TransactionType.Receipt,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.taxInvoiceIdList,
    transactionType: enums.TransactionType.TaxInvoice,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.creditNoteIdList,
    transactionType: enums.TransactionType.CreditNote,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.debitNoteIdList,
    transactionType: enums.TransactionType.DebitNote,
  });

  await store.dispatch("DoGetTransactionViewDetailForDisplay", {
    transactionIdList: objectId.billingNoteIdList,
    transactionType: enums.TransactionType.BillingNote,
  });
  //#endregion

  //#region Get Journal Code
  await store.dispatch("DoGetJournalViewDetailForDisplay", {
    journalIdList: objectId.journalIdList,
  });
  //#endregion

  //#region Get Product Code
  await store.dispatch("DoGetProductCodeForDisplay", objectId.productIdList);
  //#endregion

  //#region Get assetTemplate Code
  await store.dispatch("DoGetAssetTemplateCodeForDisplay", objectId.assetTemplateIdList);
  //#endregion

  //#region Get Bank Account Code
  await store.dispatch("DoGetBankAccountCodeForDisplay", objectId.bankAccountIdList);
  //#endregion

  const getOtherUserListMap = store.getters.GetOtherUserListMap;
  const transactionTypeListForMap = store.getters.GetTransactionTypeListForMap;
  const journalViewDetailListForMap = store.getters.GetJournalViewDetailListForMap;
  const productCodeListForMap = store.getters.GetProductCodeListForMap;
  const assetTemplateCodeListForMap = store.getters.GetAssetTemplateCodeListForMap;
  const bankAccountListForMap = store.getters.GetBankAccountListForMap;

  if (notificationList && notificationList.length > 0) {
    notificationList.forEach((notification) => {
      notification.icon = GetStatusIconNameAndColorByType(notification.messageTypeId);

      notification.message = GetSuccessHeaderReport(
        notification.messageTypeId,
        notification.option,
        notification.notificationDateTime,
        merchant,
        getOtherUserListMap,
        transactionTypeListForMap,
        journalViewDetailListForMap,
        productCodeListForMap,
        assetTemplateCodeListForMap,
        bankAccountListForMap
      );

      if (notification.option && notification.option.referenceUserId > 0) {
        notification.notificationUrlImage = GetUserImageByUserId(
          notification.option.referenceUserId,
          getOtherUserListMap
        );
      } else if (notification.notificationTypeId == enums.NotificationType.System) {
        notification.notificationUrlImage = GetNotificationUrlImageSystem(notification.messageTypeId);
      } else {
        notification.notificationUrlImage = process.env.VUE_APP_PeakFileServer.UrlCombine(
          "/peakengine/Content/Image/Notification/notification_icon_download.png"
        );
      }
    });
  }
};

export const GetUserImageByUserId = (userId, getOtherUserListMap) => {
  let userImage = "";
  if (getOtherUserListMap && getOtherUserListMap[userId]) {
    userImage = getOtherUserListMap[userId].pictureUrl;
  }
  return userImage;
};

export const GetProductCodeByProductId = (productId, productCodeListForMap) => {
  const productCode = productCodeListForMap.get(productId);
  if (productCode) {
    return productCode.productTemplateCode;
  }
  return "";
};

export const GetAssetTemplateCodeByAssetTemplateId = (assetTemplateId, assetTemplateCodeListForMap) => {
  const assetTemplateCode = assetTemplateCodeListForMap.get(assetTemplateId);
  if (assetTemplateCode) {
    return assetTemplateCode.assetTemplateCode;
  }
  return "";
};

export const GetBankAccountCodeByBankAccountId = (bankAccountId, bankAccountListForMap) => {
  const bankAccountCode = bankAccountListForMap.get(bankAccountId);
  if (bankAccountCode) {
    return bankAccountCode.code;
  }
  return "";
};

export const GetTransactionNumberFromTransactionTypeListForMap = (
  transactionId,
  transactionType,
  transactionTypeListForMap,
  journalViewDetailListForMap
) => {
  if (transactionType == enums.TransactionType.Dailyjournal) {
    const journalViewDetail = journalViewDetailListForMap.get(transactionId);
    if (journalViewDetail) {
      return journalViewDetail.number;
    }
  } else {
    const transactionNumberForMap = transactionTypeListForMap.get(transactionType);
    if (transactionNumberForMap) {
      const transactionNumber = transactionNumberForMap.get(transactionId);
      if (transactionNumber) {
        return transactionNumber.number;
      }
    }
  }

  return "";
};
export const CheckMerchantIsActiveOtherTab = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    let allTabs = await GetAllTabs();
    return allTabs.some((x) => x.id !== tabId && x.merchantId == merchantId);
  }
  return false;
};

export const CheckMerchantIsLoadNotificationUnSeen = async (merchantId) => {
  const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
  return unreadNotificationList && unreadNotificationList.length > 0 ? true : false;
};

export const CheckMerchantIsLoadNotificationIsSeen = async (merchantId) => {
  const readNotificationList = await DoGetReadAllNotificationList(merchantId);
  return readNotificationList && readNotificationList.length > 0 ? true : false;
};

export const CheckMerchantIsLoadAllNotification = async (merchantId) => {
  const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
  const readNotificationList = await DoGetReadAllNotificationList(merchantId);
  return unreadNotificationList &&
    unreadNotificationList.length > 0 &&
    readNotificationList &&
    readNotificationList.length > 0
    ? true
    : false;
};

export const CheckMerchantIsActive = async (merchantId) => {
  let isActive = false;
  if (merchantId > 0) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      let allTabs = await GetAllTabs();
      let isHaveSomeTabSameMerchant = allTabs.some((x) => x.merchantId == merchantId);
      if (isHaveSomeTabSameMerchant) {
        isActive = true;
      }
    } else {
      isActive = true;
    }
  }
  return isActive;
};

export const ForceSetMaster = async (merchantId) => {
  BroadcastDisconnectNotificationAllTab();
  ClearMasterTabFromCookies();
  ClearTabFromSessionStorage();
  await ClearTabFromIndexedDB();
  await ClearNotificationIndexedDB();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  DoGetUnseenNotificationCount(merchantId);
  BroadcastReCreateTab();
};

export const GetNotificationUrlImageSystem = (messageTypeId) => {
  switch (messageTypeId) {
    case enums.NotificationMessageType.LazadaTokenExpiredInTenDays:
    case enums.NotificationMessageType.LazadaTokenExpiredInThreeDays:
    case enums.NotificationMessageType.LazadaTokenExpired:
    case enums.NotificationMessageType.LazadaTokenDisconected:
      return process.env.VUE_APP_PeakFileServer.UrlCombine("/peakengine/Content/Image/PartnerAppLogo/Lazada.png");

    case enums.NotificationMessageType.ShopeeTokenExpiredInTenDays:
    case enums.NotificationMessageType.ShopeeTokenExpiredInThreeDays:
    case enums.NotificationMessageType.ShopeeTokenExpired:
    case enums.NotificationMessageType.ShopeeTokenDisconected:
      return process.env.VUE_APP_PeakFileServer.UrlCombine("/peakengine/Content/Image/PartnerAppLogo/Shopee.png");

    default:
      return process.env.VUE_APP_PeakFileServer.UrlCombine(
        "/peakengine/Content/Image/Notification/notification_icon_system.png"
      );
  }
};

export const GetTimeFormat = (notificationDateTime) => {
  const date = new Date(notificationDateTime);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const GetSuccessHeaderReport = (
  messageTypeId,
  option,
  notificationDateTime,
  merchant,
  otherUserListMap,
  transactionTypeListForMap,
  journalViewDetailListForMap,
  productCodeListForMap,
  assetTemplateCodeListForMap,
  bankAccountIdListForMap
) => {
  let headerMessage = "";
  let descriptionMessage = "";

  const merchantName = merchant ? merchant.merchantName : "";
  const messageDescription = option.messageDescription ? option.messageDescription : "";
  const exportFromDate = option.exportFromDate ? option.exportFromDate.GetDateFormat() : "";
  const exportToDate = option.exportToDate ? option.exportToDate.GetDateFormat() : "";
  const transactionCount = option.transactionCount ? option.transactionCount : 0;
  const transactionId = option.transactionId ? option.transactionId : 0;
  const transactionType = option.transactionType ? option.transactionType : 0;
  const financeType = option.financeType ? option.financeType : 0;
  const transactionItemType = option.transactionItemType ? option.transactionItemType : 0;
  const productId = option.productId ? option.productId : 0;
  const assetTemplateId = option.assetTemplateId ? option.assetTemplateId : 0;
  const bankAccountId = option.bankAccountId ? option.bankAccountId : 0;
  const userName = otherUserListMap[option.referenceUserId] ? otherUserListMap[option.referenceUserId].displayName : "";
  const messageUrlName = option.messageUrlName ? option.messageUrlName : "";
  const shopName = option.messageDescription ? option.messageDescription : "";
  const notificationTime = GetTimeFormat(notificationDateTime);

  switch (messageTypeId) {
    case enums.NotificationMessageType.Quotation:
      headerMessage = i18n.t("Success_QuotationReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PurcahseOrder:
      headerMessage = i18n.t("Success_POReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PurchaseOrderAsset:
      headerMessage = i18n.t("Success_POAssetReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PurchaseRequisition:
      headerMessage = i18n.t("Success_PurchaseRequisition");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Invoice:
    case enums.NotificationMessageType.InvoiceAllProduct:
      headerMessage = i18n.t("Success_InvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Expense:
    case enums.NotificationMessageType.ExpenseAllProduct:
      headerMessage = i18n.t("Success_ExpenseReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PurchaseAsset:
    case enums.NotificationMessageType.PurchaseAssetAllProduct:
      headerMessage = i18n.t("Success_PurchaseAssetReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Receipt:
      headerMessage = i18n.t("Success_ReceiptReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TaxInvoice:
    case enums.NotificationMessageType.TaxInvoiceInRevenueDepartmentFormat:
      headerMessage = i18n.t("Success_TaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PurcahseTaxInvoice:
    case enums.NotificationMessageType.PurchaseTaxInvoiceInRevenueDepartFormat:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportTaxInvoiceFromOldPeak:
      headerMessage = i18n.t("Success_TaxInvoiceReportFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceFromOldPeak:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReportFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportTaxInvoiceFromPeakTax:
      headerMessage = i18n.t("Success_TaxInvoiceReportFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceFromPeakTax:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReportFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.BillingNoteInvoice:
    case enums.NotificationMessageType.BillingNoteInvoiceAllInvoice:
      headerMessage = i18n.t("Success_BillingNoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.BillingNoteExpense:
    case enums.NotificationMessageType.BillingNoteExpenseAllExpense:
      headerMessage = i18n.t("Success_CombinePaymentNoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.StockActivityStockCardMovement:
      headerMessage = i18n.t("Success_StockMovementReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Journal:
      headerMessage = i18n.t("Success_DailyJournalReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TrialBalance:
    case enums.NotificationMessageType.TrialBalanceWithSubAccount:
      headerMessage = i18n.t("Success_TrialBalanceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TrialBalanceSeperateMonth:
      headerMessage = i18n.t("Success_TrialBalanceSeperateMonthReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Finance:
      headerMessage = i18n.t("Success_FinanceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PP30InputVat:
      headerMessage = i18n.t("Success_PP30InputVat");
      break;
    case enums.NotificationMessageType.PP30OutputVat:
      headerMessage = i18n.t("Success_PP30OutputVat");
      break;
    case enums.NotificationMessageType.CreditNote:
      headerMessage = i18n.t("Success_CreditnoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.CreditNoteExpense:
      headerMessage = i18n.t("Success_CreditnoteExpenseReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AssetTemplate:
      headerMessage = i18n.t("Success_AssetTemplateReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AssetTemplateGroup:
      headerMessage = i18n.t("Success_AssetTemplateGroupReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.WithHeldTax:
      headerMessage = i18n.t("Success_WithHeldTaxReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.WithHoldingTax:
      headerMessage = i18n.t("Success_WithHoldingTaxReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.GeneralLedgerTransaction:
      headerMessage = i18n.t("Success_GeneralLedger_Transaction");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllGeneralLedger:
      headerMessage = i18n.t("Success_AllGeneralLedger");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllGeneralLedgerWithSubAccount:
      headerMessage = i18n.t("Success_GeneralLedger_Transaction");
      break;
    case enums.NotificationMessageType.AgingReportAR:
      headerMessage = i18n.t("Success_Aging_Report_AR");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AgingReportAP:
      headerMessage = i18n.t("Success_Aging_Report_AP");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Product:
      headerMessage = i18n.t("Success_Product");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.ProfitLoss:
      headerMessage = i18n.t("Success_ProfitLoss");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.ChartOfAccount:
      headerMessage = i18n.t("Success_ChartOfAccount");
      descriptionMessage = i18n.t("Success_ChartOfAccount_Description", {
        merchantName: merchantName,
      });
      break;
    case enums.NotificationMessageType.BalanceSheet:
      headerMessage = i18n.t("Success_BalanceSheet");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Unit:
      headerMessage = i18n.t("Success_Unit");
      break;
    case enums.NotificationMessageType.ReportDocument:
      headerMessage = i18n.t("Success_ReportDocument");
      break;
    case enums.NotificationMessageType.Asset:
      headerMessage = i18n.t("Success_AssetReport");
      descriptionMessage = i18n.t("Success_AssetReport_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
        assetGroupCode: GetAssetTemplateCodeByAssetTemplateId(assetTemplateId, assetTemplateCodeListForMap),
      });
      break;
    case enums.NotificationMessageType.StatementEFiling:
      headerMessage = i18n.t("Success_StatementEFiling");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Contact:
      headerMessage = i18n.t("Success_ReportContact");
      break;
    case enums.NotificationMessageType.PurchaseTaxInvoiceNotUse:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUse");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.SalesTaxInvoiceNotUse:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUse");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromOldPeak:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUseFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromOldPeak:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUseFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromPeakTax:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUseFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromPeakTax:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUseFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.PP30TaxFilingTextFile:
      headerMessage = i18n.t("Success_PP30TaxFilingTextFile");
      break;
    case enums.NotificationMessageType.WithHoldingTaxPND2:
      headerMessage = i18n.t("Success_WithHoldingTaxPND2");
      break;
    case enums.NotificationMessageType.WithHoldingTaxPND3:
      headerMessage = i18n.t("Success_WithHoldingTaxPND3");
      break;
    case enums.NotificationMessageType.WithHoldingTaxPND53:
      headerMessage = i18n.t("Success_WithHoldingTaxPND53");
      break;
    case enums.NotificationMessageType.CashflowStatementReport:
      headerMessage = i18n.t("Success_CashflowStatementReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportSalesByCustomerReport:
      headerMessage = i18n.t("Success_AllReportSalesByCustomerReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportSalesByAccountReport:
      headerMessage = i18n.t("Success_AllReportSalesByAccountReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.StatementEFilingExcel:
      headerMessage = i18n.t("Success_StatementEFilingExcel");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportProductSalesByContact:
      headerMessage = i18n.t("Success_AllReportProductSalesByContact");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReport_ProductServiceSalesSummaryReportOnDailyAccount:
      headerMessage = i18n.t("Success_AllReport_ProductServiceSalesSummaryReportOnDailyAccount");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReport_RemainingFinanceBalanceReport:
      headerMessage = i18n.t("Success_AllReport_RemainingFinanceBalanceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.Pnd53TaxFilingTextFile:
      headerMessage = i18n.t("Success_Pnd53TaxFilingTextFile");
      break;
    case enums.NotificationMessageType.Pnd3TaxFilingTextFile:
      headerMessage = i18n.t("Success_Pnd3TaxFilingTextFile");
      break;
    case enums.NotificationMessageType.DailyJournal:
      headerMessage = i18n.t("Success_DailyJournal");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Dailyjournal, enums.FinanceType.None),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentQuotation:
      headerMessage = i18n.t("Success_DocumentQuotation");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Quotation, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentInvoice:
      headerMessage = i18n.t("Success_DocumentInvoice");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Invoice, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentReceipt:
      headerMessage = i18n.t("Success_DocumentReceipt");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Receipt, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentTaxInvoice:
      headerMessage = i18n.t("Success_DocumentTaxInvoice");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.TaxInvoice, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentPurchaseOrder:
      headerMessage = i18n.t("Success_DocumentPurchaseOrder");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Quotation, enums.FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentExpense:
      headerMessage = i18n.t("Success_DocumentExpense");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Invoice, enums.FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentBillingNote:
      headerMessage = i18n.t("Success_DocumentBillingNote");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.BillingNote, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentBillingNoteExpense:
      headerMessage = i18n.t("Success_DocumentBillingNoteExpress");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(
          enums.TransactionType.BillingNote,
          enums.FinanceType.OutFlow
        ),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentCreditNote:
      headerMessage = i18n.t("Success_DocumentCreditNote");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.CreditNote, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentCreditNoteExpense:
      headerMessage = i18n.t("Success_DocumentCreditNoteExpress");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.CreditNote, enums.FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentPurchaseTaxInvoice:
      headerMessage = i18n.t("Success_DocumentPurchaseTaxInvoice");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.TaxInvoice, enums.FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentWithholdingTax:
      headerMessage = i18n.t("Success_DocumentWithholdingTax");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(
          enums.TransactionType.WithholdingTax,
          enums.FinanceType.None
        ),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionPurchaseInventory:
      headerMessage = i18n.t("Success_ImportTransactionPurchaseInventory");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionExpense:
      headerMessage = i18n.t("Success_ImportTransactionExpense");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionInvoice:
      headerMessage = i18n.t("Success_ImportTransactionInvoice");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionReceipt:
      headerMessage = i18n.t("Success_ImportTransactionReceipt");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionQuotation:
      headerMessage = i18n.t("Success_ImportTransactionQuotation");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionPurchaseOrder:
      headerMessage = i18n.t("Success_ImportTransactionPurchaseOrder");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.Statement:
      headerMessage = i18n.t("Success_Statement");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND2:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND2");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND3:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND3");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND53:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND53");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.ChequeReport:
      headerMessage = i18n.t("Success_ChequeReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.WorkingPaper:
      headerMessage = i18n.t("Success_WorkingPaperReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.RecalCostOfGoodSoldByMerchantCalculated:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldByMerchantCalculated");
      break;
    case enums.NotificationMessageType.RecalCostOfGoodSoldByProductCalculated:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldByProductCalculated");
      descriptionMessage = i18n.t("Product_Code_Description", {
        productCode: GetProductCodeByProductId(productId, productCodeListForMap),
      });
      break;
    case enums.NotificationMessageType.RecalCostOfGoodSoldFailed:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldFailed");
      descriptionMessage = i18n.t("Product_Code_Description", {
        productCode: GetProductCodeByProductId(productId, productCodeListForMap),
      });
      break;
    case enums.NotificationMessageType.DebitNote:
      headerMessage = i18n.t("Success_DebitNoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.DebitNoteExpense:
      headerMessage = i18n.t("Success_DebitNoteExpenseReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.DocumentDebitNote:
      headerMessage = i18n.t("Success_DocumentDebitNote");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.DebitNote, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentDebitNoteExpense:
      headerMessage = i18n.t("Success_DocumentDebitNoteExpense");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.DebitNote, enums.FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentPurchaseRequisition:
      headerMessage = i18n.t("Success_DocumentPurchaseRequisition");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(
          enums.TransactionType.PurchaseRequisition,
          enums.FinanceType.OutFlow
        ),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.VoidImportTransactionFailed:
      headerMessage = i18n.t("Success_VoidImportTransactionFailed");
      descriptionMessage = i18n.t("Import_Code_Description", {
        importNumber: messageUrlName,
      });
      break;
    case enums.NotificationMessageType.VoidImportTransactionSuccess:
      headerMessage = i18n.t("Success_VoidImportTransactionSuccess");
      descriptionMessage = i18n.t("Import_Code_Description", {
        importNumber: messageUrlName,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionReceiptFromInvoice:
      headerMessage = i18n.t("Success_ImportTransactionReceiptFromInvoice");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.ImportTransactionJournal:
      headerMessage = i18n.t("Success_ImportTransactionJournal");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DepreciateAssetMonthly:
      headerMessage = i18n.t("Success_DepreciateAssetMonthly") + " " + messageDescription;
      break;
    case enums.NotificationMessageType.TaxPnd:
      headerMessage = i18n.t("Success_WithHoldingTaxReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TaxPP30SaleTax:
      headerMessage = i18n.t("Success_TaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TaxPP30PurchaseTax:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TaxFetchPP30Transaction:
      headerMessage = i18n.t("Success_TaxFetchPP30Transaction");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.TaxFetchWhtCertificate:
      headerMessage = i18n.t("Success_TaxFetchWhtCertificate");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.FinanceBankStatement:
      headerMessage = i18n.t("Success_FinanceBankStatementReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.ExecutiveSummary:
      headerMessage = i18n.t("Success_ExecutiveSummaryReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.StatementOfCashflow:
      headerMessage = i18n.t("Success_StatementOfCashflow");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.MentionTransaction:
      headerMessage = i18n.t("Success_MentionTransaction", {
        userName: userName,
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap,
          journalViewDetailListForMap
        ),
      });
      descriptionMessage = shareHelper.GetCommentTextForDisplay(messageDescription, otherUserListMap);
      break;
    case enums.NotificationMessageType.Deposit:
      headerMessage = i18n.t("Success_DepositReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.ReceiveDeposit:
      headerMessage = i18n.t("Success_ReceiveDepositReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.InvoiceReceipt:
      headerMessage = i18n.t("Success_InvoiceReceiptReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.GoodsReceipt:
      headerMessage = i18n.t("Success_GoodsReceiptReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case enums.NotificationMessageType.ApprovedTransaction:
      headerMessage = i18n.t("Success_ApprovedTransaction", {
        userName: userName,
      });
      descriptionMessage = i18n.t("Success_ApprovedTransaction_Description", {
        transactionType: GetTransactionNameForNotification(transactionType, financeType, transactionItemType),
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap,
          journalViewDetailListForMap
        ),
      });
      break;
    case enums.NotificationMessageType.SendApprovedDocumentTransaction:
      headerMessage = i18n.t("Success_SendApprovedTransaction", {
        userName: userName,
      });
      descriptionMessage = i18n.t("Success_SendApprovedTransaction_Description", {
        transactionType: GetTransactionNameForNotification(transactionType, financeType, transactionItemType),
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap,
          journalViewDetailListForMap
        ),
      });
      break;
    case enums.NotificationMessageType.RemovePeakSupport:
      headerMessage = i18n.t("Success_RemovePeakSupport");
      descriptionMessage = i18n.t("Success_RemovePeakSupport_Description");
      break;
    case enums.NotificationMessageType.ApprovedTransaction:
      headerMessage = i18n.t("Success_ApprovedTransaction", {
        userName: userName,
      });
      descriptionMessage = i18n.t("Success_ApprovedTransaction_Description", {
        transactionType: GetTransactionNameForNotification(transactionType, financeType, transactionItemType),
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap,
          journalViewDetailListForMap
        ),
      });
      break;
    case enums.NotificationMessageType.EmailAttachTooLarge:
      headerMessage = i18n.t("Success_EmailAttachTooLarge");
      descriptionMessage = "";
      break;
    case enums.NotificationMessageType.RecieveBenefit:
    case enums.NotificationMessageType.CamPaignBeforeExpire:
    case enums.NotificationMessageType.BeforeExpireByDate:
    case enums.NotificationMessageType.QuotaExpire:
      headerMessage = messageDescription;
      break;
    case enums.NotificationMessageType.PaymentTransfer:
      headerMessage = i18n.t("Download_Bulk_Payment_Transfer");
      descriptionMessage = "";
      break;
    case enums.NotificationMessageType.DocumentDepositReceipt:
      headerMessage = i18n.t("Success_DocumentDepositReceipt");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Deposit, enums.FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentDepositPayment:
      headerMessage = i18n.t("Success_DocumentDepositPayment");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(enums.TransactionType.Deposit, enums.FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentInvoiceReceipt:
      headerMessage = i18n.t("Success_InvoiceReceipt");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(
          enums.TransactionType.InvoiceReceipt,
          enums.FinanceType.OutFlow
        ),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.DocumentGoodsReceipt:
      headerMessage = i18n.t("Success_GoodsReceipt");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(
          enums.TransactionType.GoodsReceipt,
          enums.FinanceType.OutFlow
        ),
        x: transactionCount,
      });
      break;
    case enums.NotificationMessageType.LazadaTokenExpiredInTenDays:
      headerMessage = i18n.t("Lazada_10day_Noti");
      descriptionMessage = i18n.t("Lazada_Noti_Description", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.LazadaTokenExpiredInThreeDays:
      headerMessage = i18n.t("Lazada_3day_Noti");
      descriptionMessage = i18n.t("Lazada_Noti_Description", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.LazadaTokenExpired:
      headerMessage = i18n.t("Lazada_Expire_Noti");
      descriptionMessage = i18n.t("Lazada_Noti_Description", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.LazadaTokenDisconected:
      headerMessage = i18n.t("Lazada_Disconnect_Noti");
      descriptionMessage = i18n.t("Lazada_Noti_Description_Disconnect", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.ShopeeTokenExpiredInTenDays:
      headerMessage = i18n.t("Shopee_10day_Noti");
      descriptionMessage = i18n.t("Shopee_Noti_Description", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.ShopeeTokenExpiredInThreeDays:
      headerMessage = i18n.t("Shopee_3day_Noti");
      descriptionMessage = i18n.t("Shopee_Noti_Description", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.ShopeeTokenExpired:
      headerMessage = i18n.t("Shopee_Expire_Noti");
      descriptionMessage = i18n.t("Shopee_Noti_Description", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.ShopeeTokenDisconected:
      headerMessage = i18n.t("Shopee_Disconnect_Noti");
      descriptionMessage = i18n.t("Shopee_Noti_Description_Disconnect", {
        shopName: shopName,
      });
      break;
    case enums.NotificationMessageType.BankAccountChanged:
      headerMessage = i18n.t("Bank_Account_Changed", {
        financeCode: GetBankAccountCodeByBankAccountId(bankAccountId, bankAccountIdListForMap),
      });
      descriptionMessage = i18n.t("Bank_Account_Changed_Description", {
        username: userName,
        date: notificationDateTime.GetDateFormat(),
        time: notificationTime,
      });
      break;
    case enums.NotificationMessageType.PaymentChannelChanged:
      headerMessage = i18n.t("Payment_Channel_Changed");
      descriptionMessage = i18n.t("Payment_Channel_Changed_Description", {
        username: userName,
        date: notificationDateTime.GetDateFormat(),
        time: notificationTime,
      });
      break;
  }
  return { headerMessage, descriptionMessage };
};

export const GetTransactionNameForNotification = (
  transactionType,
  financeType,
  transactionItemType = enums.TransactionItemType.None
) => {
  let name = "";
  switch (transactionType) {
    case enums.TransactionType.Quotation:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Quotation");
      } else {
        if (transactionItemType == enums.TransactionItemType.Asset) {
          name = i18n.t("Purchase_Order_Asset");
        } else {
          name = i18n.t("Purchase_Order");
        }
      }
      break;
    case enums.TransactionType.Deposit:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Deposit_Receipt");
      } else {
        name = i18n.t("Deposit_Payment");
      }
      break;
    case enums.TransactionType.GoodsReceipt:
      name = i18n.t("Goods_Receipt");
      break;
    case enums.TransactionType.InvoiceReceipt:
      name = i18n.t("Invoice_Receipt");
      break;
    case enums.TransactionType.Invoice:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Invoice");
      } else {
        if (transactionItemType == enums.TransactionItemType.Asset) {
          name = i18n.t("Purchase_New_Asset");
        } else {
          name = i18n.t("Expense");
        }
      }
      break;
    case enums.TransactionType.Receipt:
      name = i18n.t("Receipt");
      break;
    case enums.TransactionType.TaxInvoice:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Sales_Tax_Invoice");
      } else {
        name = i18n.t("Purchase_Tax_Invoice");
      }
      break;
    case enums.TransactionType.CreditNote:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Credit_Note");
      } else {
        name = i18n.t("Receive_Credit_Note");
      }

      break;
    case enums.TransactionType.DebitNote:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Debit_Note");
      } else {
        name = i18n.t("Receive_Debit_Note");
      }
      break;
    case enums.TransactionType.BillingNote:
      if (financeType == enums.FinanceType.InFlow) {
        name = i18n.t("Menu_BillingNote");
      } else {
        name = i18n.t("Combined_Payment_Note");
      }
      break;
    case enums.TransactionType.Dailyjournal:
      name = i18n.t("Daily_Journal");
      break;
    case enums.TransactionType.WithholdingTax:
      name = i18n.t("Withholding_Tax_Certificate_Header");
      break;
    case enums.TransactionType.PurchaseRequisition:
      name = i18n.t("Menu_PurchaseRequisition");
      break;
  }

  return name;
};

export const GetStatusIconNameAndColorByType = (messageTypeId) => {
  switch (messageTypeId) {
    case enums.NotificationMessageType.ImportTransactionPurchaseInventory:
    case enums.NotificationMessageType.ImportTransactionExpense:
    case enums.NotificationMessageType.ImportTransactionInvoice:
    case enums.NotificationMessageType.ImportTransactionReceipt:
    case enums.NotificationMessageType.ImportTransactionQuotation:
    case enums.NotificationMessageType.ImportTransactionPurchaseOrder:
    case enums.NotificationMessageType.ImportTransactionReceiptFromInvoice:
    case enums.NotificationMessageType.ImportTransactionJournal:
      return {
        name: "fas fa-file-upload",
        color: "#43BF76",
      };
    case enums.NotificationMessageType.VoidImportTransactionFailed:
    case enums.NotificationMessageType.EmailAttachTooLarge:
      return {
        name: "icon-file_error",
        color: "#F1502F",
      };
    case enums.NotificationMessageType.MentionTransaction:
      return {
        name: "icon-mention",
        color: "#5CACFF",
      };
    case enums.NotificationMessageType.RemovePeakSupport:
      return {
        name: "fas fa-user-slash",
        color: "#FF6547",
      };
    case enums.NotificationMessageType.ApprovedTransaction:
      return {
        name: "icon-file_success",
        color: "#43BF76",
      };
    case enums.NotificationMessageType.SendApprovedDocumentTransaction:
      return {
        name: "fas fa-clock",
        color: "#ff9e40",
      };
    case enums.NotificationMessageType.RecieveBenefit:
    case enums.NotificationMessageType.CamPaignBeforeExpire:
    case enums.NotificationMessageType.BeforeExpireByDate:
    case enums.NotificationMessageType.QuotaExpire:
    case enums.NotificationMessageType.RecalCostOfGoodSoldByMerchantCalculated:
    case enums.NotificationMessageType.RecalCostOfGoodSoldByProductCalculated:
    case enums.NotificationMessageType.RecalCostOfGoodSoldFailed:
    case enums.NotificationMessageType.VoidImportTransactionSuccess:
    case enums.NotificationMessageType.DepreciateAssetMonthly:
    case enums.NotificationMessageType.BankAccountChanged:
    case enums.NotificationMessageType.PaymentChannelChanged:
      return {
        name: "fas fa-check-circle",
        color: "#43BF76",
      };
    case enums.NotificationMessageType.DocumentQuotation:
    case enums.NotificationMessageType.DocumentInvoice:
    case enums.NotificationMessageType.DocumentReceipt:
    case enums.NotificationMessageType.DocumentTaxInvoice:
    case enums.NotificationMessageType.DocumentPurchaseOrder:
    case enums.NotificationMessageType.DocumentExpense:
    case enums.NotificationMessageType.DocumentBillingNote:
    case enums.NotificationMessageType.DocumentBillingNoteExpense:
    case enums.NotificationMessageType.DocumentCreditNote:
    case enums.NotificationMessageType.DocumentCreditNoteExpense:
    case enums.NotificationMessageType.DocumentPurchaseTaxInvoice:
    case enums.NotificationMessageType.DocumentWithholdingTax:
    case enums.NotificationMessageType.DocumentDebitNote:
    case enums.NotificationMessageType.DocumentDebitNoteExpense:
    case enums.NotificationMessageType.DailyJournal:
    case enums.NotificationMessageType.DocumentDepositReceipt:
    case enums.NotificationMessageType.DocumentDepositPayment:
    case enums.NotificationMessageType.DocumentPurchaseRequisition:
      return {
        name: "fas fa-file-pdf",
        color: "#F1502F",
      };
    case enums.NotificationMessageType.ReportDocument:
    case enums.NotificationMessageType.StatementEFiling:
      return {
        name: "fas fa-file-alt",
        color: "#6c6df2",
      };
    case enums.NotificationMessageType.PP30TaxFilingTextFile:
    case enums.NotificationMessageType.WithHoldingTaxPND2:
    case enums.NotificationMessageType.WithHoldingTaxPND3:
    case enums.NotificationMessageType.WithHoldingTaxPND53:
    case enums.NotificationMessageType.PaymentTransfer:
      return {
        name: "icon-file_text",
        color: "#3297FF",
      };
    case enums.NotificationMessageType.AgingReportAP:
    case enums.NotificationMessageType.AgingReportAR:
    case enums.NotificationMessageType.AllGeneralLedger:
    case enums.NotificationMessageType.Asset:
    case enums.NotificationMessageType.AssetTemplateGroup:
    case enums.NotificationMessageType.AssetTemplate:
    case enums.NotificationMessageType.BalanceSheet:
    case enums.NotificationMessageType.BillingNoteInvoice:
    case enums.NotificationMessageType.BillingNoteInvoiceAllInvoice:
    case enums.NotificationMessageType.ChartOfAccount:
    case enums.NotificationMessageType.BillingNoteExpense:
    case enums.NotificationMessageType.BillingNoteExpenseAllExpense:
    case enums.NotificationMessageType.CreditNoteExpense:
    case enums.NotificationMessageType.CreditNote:
    case enums.NotificationMessageType.Journal:
    case enums.NotificationMessageType.Expense:
    case enums.NotificationMessageType.ExpenseAllProduct:
    case enums.NotificationMessageType.Finance:
    case enums.NotificationMessageType.GeneralLedgerTransaction:
    case enums.NotificationMessageType.Invoice:
    case enums.NotificationMessageType.InvoiceAllProduct:
    case enums.NotificationMessageType.PurcahseOrder:
    case enums.NotificationMessageType.PurchaseOrderAsset:
    case enums.NotificationMessageType.PurchaseRequisition:
    case enums.NotificationMessageType.PP30InputVat:
    case enums.NotificationMessageType.PP30OutputVat:
    case enums.NotificationMessageType.Product:
    case enums.NotificationMessageType.ProfitLoss:
    case enums.NotificationMessageType.PurchaseAsset:
    case enums.NotificationMessageType.PurchaseAssetAllProduct:
    case enums.NotificationMessageType.PurcahseTaxInvoice:
    case enums.NotificationMessageType.PurchaseTaxInvoiceInRevenueDepartFormat:
    case enums.NotificationMessageType.Quotation:
    case enums.NotificationMessageType.Receipt:
    case enums.NotificationMessageType.StockActivityStockCardMovement:
    case enums.NotificationMessageType.TaxPP30SaleTax:
    case enums.NotificationMessageType.TrialBalanceWithSubAccount:
    case enums.NotificationMessageType.Unit:
    case enums.NotificationMessageType.WithHeldTax:
    case enums.NotificationMessageType.WithHoldingTax:
    case enums.NotificationMessageType.Contact:
    case enums.NotificationMessageType.PurchaseTaxInvoiceNotUse:
    case enums.NotificationMessageType.SalesTaxInvoiceNotUse:
    case enums.NotificationMessageType.CashflowStatementReport:
    case enums.NotificationMessageType.AllReportSalesByCustomerReport:
    case enums.NotificationMessageType.AllReportSalesByAccountReport:
    case enums.NotificationMessageType.AllReportProductSalesByContact:
    case enums.NotificationMessageType.AllReport_ProductServiceSalesSummaryReportOnDailyAccount:
    case enums.NotificationMessageType.AllReport_RemainingFinanceBalanceReport:
    case enums.NotificationMessageType.Pnd53TaxFilingTextFile:
    case enums.NotificationMessageType.Pnd3TaxFilingTextFile:
    case enums.NotificationMessageType.Statement:
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND2:
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND3:
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND53:
    case enums.NotificationMessageType.ChequeReport:
    case enums.NotificationMessageType.WorkingPaper:
    case enums.NotificationMessageType.TrialBalanceSeperateMonth:
    case enums.NotificationMessageType.TaxFetchPP30Transaction:
    case enums.NotificationMessageType.TaxFetchWhtCertificate:
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceFromOldPeak:
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceFromPeakTax:
    case enums.NotificationMessageType.AllReportTaxInvoiceFromOldPeak:
    case enums.NotificationMessageType.AllReportTaxInvoiceFromPeakTax:
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromOldPeak:
    case enums.NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromOldPeak:
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromPeakTax:
    case enums.NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromPeakTax:
    case enums.NotificationMessageType.FinanceBankStatement:
    case enums.NotificationMessageType.ExecutiveSummary:
    case enums.NotificationMessageType.StatementOfCashflow:
    case enums.NotificationMessageType.StatementEFilingExcel:
    case enums.NotificationMessageType.DebitNote:
    case enums.NotificationMessageType.DebitNoteExpense:
    case enums.NotificationMessageType.TaxInvoice:
    case enums.NotificationMessageType.TaxInvoiceInRevenueDepartmentFormat:
    case enums.NotificationMessageType.TaxPnd:
    case enums.NotificationMessageType.TaxPP30PurchaseTax:
    case enums.NotificationMessageType.TrialBalance:
    case enums.NotificationMessageType.Deposit:
    case enums.NotificationMessageType.ReceiveDeposit:
    case enums.NotificationMessageType.InvoiceReceipt:
    case enums.NotificationMessageType.GoodsReceipt:
      return {
        name: "fas fa-file-excel",
        color: "#2E8552",
      };
    case enums.NotificationMessageType.LazadaTokenExpiredInTenDays:
    case enums.NotificationMessageType.ShopeeTokenExpiredInTenDays:
    case enums.NotificationMessageType.LazadaTokenExpiredInThreeDays:
    case enums.NotificationMessageType.ShopeeTokenExpiredInThreeDays:
      return {
        name: "fas fa-solid fa-clock",
        color: "#FF9E40",
      };
    case enums.NotificationMessageType.LazadaTokenExpired:
    case enums.NotificationMessageType.ShopeeTokenExpired:
    case enums.NotificationMessageType.LazadaTokenDisconected:
    case enums.NotificationMessageType.ShopeeTokenDisconected:
      return {
        name: "fas fa-solid fa-clock",
        color: "#FF6547",
      };
    default:
      return {
        name: "",
        color: "",
      };
  }
  // icon for send approve
  // name: "fas fa-clock",
  // color: "#FF9E40",
};

export const CheckNotificationIsNotChangeURL = (messageTypeId) => {
  const notificationTypeSystemNoAction = new Set([
    enums.NotificationMessageType.DepreciateAssetMonthly,
    enums.NotificationMessageType.RemovePeakSupport,
    enums.NotificationMessageType.EmailAttachTooLarge,
    enums.NotificationMessageType.BankAccountChanged,
    enums.NotificationMessageType.PaymentChannelChanged,
  ]);
  return notificationTypeSystemNoAction.has(messageTypeId);
};
